import React from "react";
import PropTypes from "prop-types";
import { ListItem } from "material-ui/List";
import { withRouter } from "react-router-dom";
import { withStyles } from "material-ui/styles";
import Typography from "material-ui/Typography";

import logo from "./images/conductor_logo.svg";

const styles = theme => ({
  logo: {
    height: 40
  },
  siteName: {
    color: "rgba(0,0,0,0.3)",
    textAlign: "right",
    width: "100%",
    lineHeight: 1.5
  }
});

const DrawerHeader = props => {
  const { classes, date, build, mode } = props;

  return (
    <ListItem divider className={classes.logo}>
      <img style={{ height: 55 }} src={logo} alt="Contemplative Reptile" />
      <Typography
        className={classes.siteName}
        type="caption"
        gutterBottom
        align="right"
      >
        Superuser console<br />Build:{build} [{mode}]
        <br />
        {date}
      </Typography>
    </ListItem>
  );
};

DrawerHeader.propTypes = {
  date: PropTypes.string,
  build: PropTypes.string,
  mode: PropTypes.string
};

export { DrawerHeader };

export default withStyles(styles, { name: "DrawerHeader" })(
  withRouter(DrawerHeader)
);



// WEBPACK FOOTER //
// ./src/DrawerHeader.js